module.exports = __webpack_public_path__ + "media/assets/images/check_off_on-93f78202ff7961071f7bf56aa8f51384.png";